import { render, staticRenderFns } from "./WaveDiffractionSlitViz.vue?vue&type=template&id=741a036c&scoped=true"
import script from "./WaveDiffractionSlitViz.vue?vue&type=script&lang=js"
export * from "./WaveDiffractionSlitViz.vue?vue&type=script&lang=js"
import style0 from "./WaveDiffractionSlitViz.vue?vue&type=style&index=0&id=741a036c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741a036c",
  null
  
)

export default component.exports